import { ManagedLinkKey } from "./managedLinkKey";

// Este enumerado de sedes define además el orden de las solapas en el componente menu comedor
export enum MENU_COMEDOR_SEDE { BUENOS_AIRES, SAN_JUSTO }
export enum MENU_COMEDOR_TURNO { A, C };

export const MENU_COMEDOR_OPCIONES: string[] = [ "entrada", "principal", "vegetariana", "postre" ]
export const MENU_SEDE_TITLES: { [k:string]: string } = {};
MENU_SEDE_TITLES[ MENU_COMEDOR_SEDE[ MENU_COMEDOR_SEDE.BUENOS_AIRES ] ] = "Central";
MENU_SEDE_TITLES[ MENU_COMEDOR_SEDE[ MENU_COMEDOR_SEDE.SAN_JUSTO ] ] = "San Justo";
export const MENU_COMEDOR_TURNO_TITLES: { [k:string]: string } = {};
MENU_COMEDOR_TURNO_TITLES[ MENU_COMEDOR_TURNO[ MENU_COMEDOR_TURNO.A ] ] = "Almuerzo";
MENU_COMEDOR_TURNO_TITLES[ MENU_COMEDOR_TURNO[ MENU_COMEDOR_TURNO.C ] ] = "Cena";
export const MENU_SUGERENCIAS: { [k:string]: string } = {};
MENU_SUGERENCIAS[ MENU_COMEDOR_SEDE[ MENU_COMEDOR_SEDE.BUENOS_AIRES ] ] = ManagedLinkKey.MENU_CENTRAL_SUGERENCIAS;
MENU_SUGERENCIAS[ MENU_COMEDOR_SEDE[ MENU_COMEDOR_SEDE.SAN_JUSTO ] ] = ManagedLinkKey.MENU_SAN_JUSTO_SUGERENCIAS;


export interface MenuComedor {
	entrada: string[],
	principal: string[],
	vegetariana: string[],
	postre: string[],
	fechaAsString: string
}

export interface MenuComedorStatus {
	fecha: Date,
	idMenu: number,
	turno: MENU_COMEDOR_TURNO
}

export interface MenuComedorSede {
	sede: MENU_COMEDOR_SEDE,
}

export interface MenuComedorSedeRecord extends MenuComedorSede {
	menu: MenuComedor,
	status?: MenuComedorStatus
}

export interface MenuComedorSedeStatus extends MenuComedorSede {
	status: MenuComedorStatus
}


// Title related interfaces
export interface MenuComedorTitle {
	entrada: string,
	principal: string,
	vegetariana: string,
	postre: string
}

export const MENU_COMEDOR_TITLES: MenuComedorTitle = {
	entrada: "Entradas",
	principal: "Plato principal",
	vegetariana: "Opción vegetariana",
	postre: "Postres"
}

